import React, { useState } from 'react'
import { Form, Button, Table, message, Drawer } from 'antd'
import { Loading, Icon } from '@guillotinaweb/react-gmi'
import { useLocation } from 'wouter'
import { useMutation, useQuery } from 'urql'
import { CreateInvoiceMutation, ListInvoicesQuery } from './graphql'
import { ContentLayout } from '../../../common/content-layout'

import { UserSelector } from '../../../components/user-selector'

import './styles.css'

export function ListInvoices() {
  const [page, setPage] = useState(0)
  const [openCreate, setOpenCreate] = useState(false)
  const [, setLocation] = useLocation()
  const [res, reloadList] = useQuery({
    query: ListInvoicesQuery,
    variables: { page },
    ...(window.location.search.includes('refresh=1')
      ? {
          requestPolicy: 'network-only', // invalidate cache
        }
      : {}),
  })

  return (
    <ContentLayout
      title="List of multi-order invoices"
      loading={res.fetching}
      error={res.error}
      buttonLabel={
        <>
          <Icon icon="fas fa-plus" />
          <span>Create</span>
        </>
      }
      buttonAction={() => setOpenCreate(true)}
    >
      <Table
        dataSource={res?.data?.invoice_multiorder_search?.data}
        columns={[
          {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
          },
          {
            title: 'Customer',
            key: 'nombre',
            dataIndex: 'nombre',
            render: (name, o) => `${o.id_usuario} - ${name} - ${o.email}`,
          },
          {
            title: 'Nº Orders',
            dataIndex: 'id_pedidos',
            key: 'id_pedidos',
            render: (v) => {
              if (!v) return '0'
              return v.length
            },
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (v) => {
              const color = v === 'DRAFT' ? '#F44336' : '#009688'
              return <div style={{ color }}>{v}</div>
            },
          },
        ]}
        rowKey={(record) => record.id}
        onRow={({ id }) => ({
          onClick: () => setLocation(`/orders/multi-order-invoice/${id}`),
        })}
        pagination={{
          current: page + 1,
          pageSize: 100,
          total: res?.data?.invoice_multiorder_search?.amount,
          position: ['topLeft', 'bottomRight'],
          showSizeChanger: false,
          onChange: (page) => setPage(page - 1),
        }}
        size="small"
      />
      <Drawer
        title="Add a new invoice"
        width={400}
        onClose={() => setOpenCreate(false)}
        visible={openCreate}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <CreateInvoice
          key={openCreate}
          onSuccess={async () => {
            await setOpenCreate(false)
            reloadList({ requestPolicy: 'network-only' })
          }}
        />
      </Drawer>
    </ContentLayout>
  )
}

export function CreateInvoice({ onSuccess }) {
  const [loading, setLoading] = useState(false)
  const [, create] = useMutation(CreateInvoiceMutation)

  return (
    <Form
      name="basic"
      onFinish={async ({ email }) => {
        const { id_usuario } = email
        try {
          setLoading(true)
          const res = await create({ id_usuario: parseInt(id_usuario, 10) })
          if (res.error?.message) return message.error(res.error?.message)
          message.success('Created!')
          onSuccess()
        } catch (e) {
          message.error(e.message)
        } finally {
          setLoading(false)
        }
      }}
    >
      <Form.Item
        label="email"
        name="email"
        rules={[{ required: true, message: 'Please input the email' }]}
      >
        <UserSelector />
      </Form.Item>
      <Form.Item>
        <Button disabled={loading} type="primary" htmlType="submit">
          Create
        </Button>
      </Form.Item>
      {loading && <Loading />}
    </Form>
  )
}
